import { useModal } from 'hooks'
import { IChangeValueGridInjectedProps } from 'screens/NutritionistsOrganization/NutritionistsGrid/ChangeManager'
import { EhrCoachSpecialty } from 'types'
import { ChangeSpecialtiesModal } from './ChangeSpecialtiesModal'

export const COACH_SPECIALTIES = [
  EhrCoachSpecialty.WeightConcerns,
  EhrCoachSpecialty.PrediabetesDiabetes,
  EhrCoachSpecialty.HealthOptimization,
  EhrCoachSpecialty.WomensHealth,
  EhrCoachSpecialty.ChronicFatigue,
  EhrCoachSpecialty.GutHealth,
  EhrCoachSpecialty.FoodAllergies,
  EhrCoachSpecialty.ThyroidDisorders,
  EhrCoachSpecialty.SportsPerformance,
  EhrCoachSpecialty.MindfulEating,
  EhrCoachSpecialty.HealthyAging,
  EhrCoachSpecialty.HeartDisease,
  EhrCoachSpecialty.Fertility,
  EhrCoachSpecialty.PrenatalNutrition,
  EhrCoachSpecialty.AutoimmuneConditions,
  EhrCoachSpecialty.EatingDisorders,
  EhrCoachSpecialty.Cancer,
  EhrCoachSpecialty.Bariatric,
  EhrCoachSpecialty.MensHealth,
  EhrCoachSpecialty.HormonalHealth,
  EhrCoachSpecialty.IntegrativeFunctionalNutrition,
  EhrCoachSpecialty.StressManagement,
  EhrCoachSpecialty.MetabolicHealth,
  EhrCoachSpecialty.Osteoporosis,
  EhrCoachSpecialty.KidneyStones
] as const

export const LABEL_BY_COACH_SPECIALTY: { [key in EhrCoachSpecialty]: string } = {
  [EhrCoachSpecialty.WeightConcerns]: 'Weight concerns',
  [EhrCoachSpecialty.PrediabetesDiabetes]: 'Prediabetes & diabetes',
  [EhrCoachSpecialty.HealthOptimization]: 'Health optimization',
  [EhrCoachSpecialty.WomensHealth]: "Women's health",
  [EhrCoachSpecialty.ChronicFatigue]: 'Chronic fatigue/Low energy levels',
  [EhrCoachSpecialty.GutHealth]: 'Gut health',
  [EhrCoachSpecialty.FoodAllergies]: 'Food allergies & intolerances',
  [EhrCoachSpecialty.ThyroidDisorders]: 'Thyroid disorders',
  [EhrCoachSpecialty.SportsPerformance]: 'Sports & performance',
  [EhrCoachSpecialty.MindfulEating]: 'Mindful/Intuitive eating',
  [EhrCoachSpecialty.HealthyAging]: 'Healthy aging',
  [EhrCoachSpecialty.HeartDisease]: 'Heart disease',
  [EhrCoachSpecialty.Fertility]: 'Fertility',
  [EhrCoachSpecialty.PrenatalNutrition]: 'Prenatal/Postnatal nutrition',
  [EhrCoachSpecialty.AutoimmuneConditions]: 'Autoimmune conditions',
  [EhrCoachSpecialty.EatingDisorders]: 'Eating disorders',
  [EhrCoachSpecialty.Cancer]: 'Cancer',
  [EhrCoachSpecialty.Bariatric]: 'Bariatric',
  [EhrCoachSpecialty.MensHealth]: "Men's health",
  [EhrCoachSpecialty.HormonalHealth]: 'Hormonal health',
  [EhrCoachSpecialty.IntegrativeFunctionalNutrition]: 'Integrative & functional nutrition',
  [EhrCoachSpecialty.StressManagement]: 'Stress management',
  [EhrCoachSpecialty.MetabolicHealth]: 'Metabolic health',
  [EhrCoachSpecialty.Osteoporosis]: 'Osteoporosis',
  [EhrCoachSpecialty.KidneyStones]: 'Kidney Stones/Metabolic Stone Disease'
}

// Generate the reverse mapping automatically
export const COACH_SPECIALTY_BY_LABEL: { [key: string]: EhrCoachSpecialty } = Object.fromEntries(
  Object.entries(LABEL_BY_COACH_SPECIALTY).map(([specialty, label]) => [
    label,
    specialty as EhrCoachSpecialty
  ])
) as { [key: string]: EhrCoachSpecialty }

export const ChangeSpecialties = (props: IChangeValueGridInjectedProps) => {
  const { rowId, field, userId } = props

  const { closeModal: closeChangeSpecialtiesModal } = useModal()

  return (
    <ChangeSpecialtiesModal
      rowId={rowId}
      field={field}
      userId={userId}
      closeModal={closeChangeSpecialtiesModal}
      modalState
    />
  )
}
